let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jVjxu")).then(() => parcelRequire('ddWy7'));